import { CheckCircle2 } from "@tamagui/lucide-icons";
import { useTranslation } from "react-i18next";
import { Location, useLocation, useNavigate } from "react-router";
import { Circle, Text, Token, View, YStack, getTokenValue } from "tamagui";
import { GradientButton } from "tamagui-config";

import { GlowCircle } from "../components/GlowCircle";

const ForgotPasswordConfirmation = () => {
  const { state } = useLocation() as Location<{ email: string } | undefined>;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = state?.email;

  const checkmarkGradientStart = getTokenValue(
    "$gradientSuccessCheckmarkStart" as Token,
    "color",
  );
  const checkmarkGradientEnd = getTokenValue(
    "$gradientSuccessCheckmarkEnd" as Token,
    "color",
  );

  const onContinuePress = () => {
    navigate("/reset-password", { state: { email } });
  };

  return (
    <View
      position="relative"
      minHeight="100vh"
      alignItems="center"
      justifyContent="center"
      backgroundColor="black"
    >
      <View position="absolute" width="100%" height="100%">
        <GlowCircle />
      </View>

      <YStack
        gap="$6"
        width={473}
        maxWidth="100%"
        padding="$7"
        backgroundColor="$transparentBorder"
        borderWidth={2}
        borderColor="$transparentBorder"
        borderRadius="$8"
      >
        <YStack gap="$6" padding="$3.5" alignItems="center">
          <YStack gap="$2.5" paddingHorizontal="$5" paddingBottom="$3.5">
            <Text
              fontSize="$7.5"
              fontWeight="bold"
              color="$white12"
              textAlign="center"
            >
              {t("forgotPasswordConfirmation.title")}
            </Text>
            <Text color="$white10" textAlign="center">
              {t("forgotPasswordConfirmation.description")}
            </Text>
          </YStack>

          <View position="relative">
            <GlowCircle
              position="absolute"
              top={-(1000 / 2) + 120 / 2}
              left={-(1000 / 2) + 120 / 2}
              size={1000}
              color="$successGreen"
              opacity={0.15}
              gradientSize="150px 150px"
              gradientOrigin="50% 50%"
            />
            <Circle
              size={120}
              backgroundImage={`linear-gradient(231.68deg, ${checkmarkGradientStart} 34.15%, ${checkmarkGradientEnd} 64.88%)`}
              backgroundOrigin="border-box"
              borderWidth={2}
              borderColor="$transparentBorder"
            >
              <CheckCircle2 size={60} color="$successGreen" />
            </Circle>
          </View>

          <GradientButton rounded width="100%" onPress={onContinuePress}>
            {t("forgotPasswordConfirmation.continueButton")}
          </GradientButton>
        </YStack>
      </YStack>
    </View>
  );
};

export default ForgotPasswordConfirmation;
